

























































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import Tools from '../../../../../lib/tools';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'reservePlanDrill',
	components: {
		QuickTable
	}
})
export default class ReservePlanDrill extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		organizations: [],			// 部门数据
		formData: {
			id: '',
			belongDepId: '',
			reservePlanName: '',
			drillDt: '',
			commander: '',
			drillOrganization: '',
			drillLeader: '',
			drillDepMembers: '',
			imaginary: '',
			drillProcess: '',
			drillExistProblem: '',
			evaluation: '',
			reviseDt: '',
			remark: ''
		},
		validate: {
			reservePlanName: [
				{ required: true, message: '请填写应急预案名称', trigger: 'blur' }
			],
			belongDepId: [
				{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }
			]
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '部门',
				key: 'belongDep',
				width: 128,
				render: (h:any, params:any) => {
					return h('span', params.row.belongDep ? params.row.belongDep.displayName : '');
				}
			},
			{
				title: '应急预案名称',
				key: 'reservePlanName',
				width: 180
			},
			{
				title: '演练日期',
				key: 'drillDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.drillDt));
				}
			},
			{
				title: '指挥长',
				key: 'commander',
				width: 86
			},
			{
				title: '演练组织部门',
				key: 'drillOrganization',
				width: 128
			},
			{
				title: '演练负责人',
				key: 'drillLeader',
				width: 128
			},
			{
				title: '演练参与部门',
				key: 'drillDepMembers',
				width: 128
			},
			{
				title: '假象事件概况',
				key: 'imaginary',
				minWidth: 160
			},
			{
				title: '演练过程记录',
				key: 'drillProcess',
				minWidth: 160
			},
			{
				title: '演练中存在的问题及整改措施',
				key: 'drillExistProblem',
				minWidth: 200
			},
			{
				title: '有效性评价及冤案完善意见',
				key: 'evaluation',
				minWidth: 200
			},
			{
				title: '修订日期',
				key: 'reviseDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.reviseDt));
				}
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = params.row[k];
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'birthday' || k == 'trainDt' || k == 'reviewDt') {
							params[k] = Tools.formatDate(datas[k]);
						}else{
							params[k] = datas[k];
						}
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/EmergencyRescue/UpdateReservePlanDrillAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/EmergencyRescue/CreateReservePlanDrillAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此预案演练与评价？',
            onOk: () => {
                Ajax.delete('/api/services/app/EmergencyRescue/DeleteReservePlanDrillAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
